import { JSONUtilites } from '../../../helpers/JSONUtilites';

export class DiscountCoupon {
  private _name: string;
  private _amount: number;
  private _combine: boolean;
  private _code: string;
  private _is_billwerk_coupon: boolean;

  constructor(
    name: string,
    amount: number,
    combine: boolean,
    code: string,
    is_billwerk_coupon: boolean,
  ) {
    this._name = name;
    this._amount = amount;
    this._combine = combine;
    this._code = code;
    this._is_billwerk_coupon = is_billwerk_coupon;
  }

  static arrayFromJSON(json: string): DiscountCoupon[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: DiscountCoupon[] = [];
    for (const item of values) {
      result.push(DiscountCoupon.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): DiscountCoupon {
    if (object === null || object === undefined) {
      return null;
    }

    return new DiscountCoupon(
      object.name,
      object.amount,
      object.combine,
      object.code,
      object.is_billwerk_coupon,
    );
  }

  static createFromOrderLine(object: any): DiscountCoupon {
    if (object === null || object === undefined) {
      return null;
    }

    return new DiscountCoupon(
      object.name,
      -object.price,
      false,
      object.coupon,
      false
    );
  }

  static getTotalDiscountCouponAmount(coupons: DiscountCoupon[]): number {
    if (!coupons || !coupons.length) {
      return 0;
    }
    return coupons.reduce(
      (pv, cv) => pv + cv.amount,
      0
    );
  }

  get name(): string {
    return this._name;
  }

  get amount(): number {
    return this._amount;
  }

  set amount(value: number) {
    this._amount = value;
  }

  get combine(): boolean {
    return this._combine;
  }

  get code(): string {
    return this._code;
  }

  get is_billwerk_coupon(): boolean {
    return this._is_billwerk_coupon;
  }

  toJSON(): any {
    return {
      amount: this._amount,
      name: this._name,
      combine: this._combine,
      code: this._code,
      is_billwerk_coupon: this._is_billwerk_coupon,
    };
  }

  clone(): DiscountCoupon {
    return JSONUtilites.fromJSON<DiscountCoupon>(null, JSON.stringify(this), DiscountCoupon.createFromAny);
  }
}
